import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EtapaRastreio } from '../models/etapa-rastreio';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class EtapaRastreioService {

  constructor(private http: HttpClient) { }

  salvar(etapa: EtapaRastreio) {
    return this.http.post(globals.apiUrl + '/api/EtapaRastreio/Salvar', etapa);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/EtapaRastreio/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/EtapaRastreio/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  consultar() {
    let parametros = new HttpParams();

    return this.http.get<any>(globals.apiUrl + '/api/EtapaRastreio/Listar',
      { params: parametros }
    );
  }

  consultarComPaginacao(nome, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc, ativo) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('nome', nome ? nome : '')
      .set('ativo', ativo.toString());

    return this.http.get<any>(globals.apiUrl + '/api/EtapaRastreio/ListaPag',
      {
        params: parametros
      });
  }
}
